// extracted by mini-css-extract-plugin
export default {"readContent":"App_readContent__yDhtq"};